import { Box, Typography, Card } from "@mui/material";

const CustomInfoCard = ({ title, date, details, handleClick, icon, iconElement, action, logo }) => {
  return (
    <Card
      onClick={handleClick}
      sx={{
        padding: "1.5em",
        marginBottom: "1em",
        cursor: "pointer",
        transition: "all 0.3s ease",
        display: "flex",
        gap: "1.5em",
        alignItems: "flex-start",
        "&:hover": {
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          transform: "translateY(-2px)",
        },
      }}
    >
      <Box sx={{ minWidth: "3em", display: "flex", alignItems: "center" }}>
        {iconElement ? iconElement : <img src={icon} alt="" style={{ width: "48px" }} />}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
            {title}
          </Typography>
          {logo}
        </Box>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5 }}>
          {date}
        </Typography>
        <Typography variant="body2" sx={{ color: "#666", noWrap: true }}>
          {details}
        </Typography>
      </Box>
      <Typography
        variant="button"
        sx={{
          color: "primary.main",
          fontWeight: 600,
          minWidth: "max-content",
          cursor: "pointer",
          fontSize: "0.875rem",
        }}
      >
        {action}
      </Typography>
    </Card>
  );
};

export default CustomInfoCard;
